<template id="bulklistmodal">
<div class="modal fade" :id="id" tabindex="-1" role="dialog" aria-labelledby="myModalLabel" style="overflow-y:auto">
  <div class="modal-dialog" role="document" v-if="params.nostock != null && params.ltstock != null">
    <div class="modal-content">
      <div class="modal-header">
          <div class="icon">
            <i :class="'fa fa-fw fa-bell'"></i>
          </div>
	  <!--img class="img-responsive" src="@/images/popthumb2.png" alt=""-->
        <!--<button type="button" class="close" data-dismiss="modal" aria-label="Close"><span aria-hidden="true">&times;</span></button>-->
        <h4 class="modal-title" id="myModalLabel">{{res.itemadj}}</h4>
      </div>
      <div class="modal-body">
	  
        <div class="stockOuter stockOuter01" v-if="params.nostock.length > 0">
          <div class="erorContent">
              <p><img class="img-responsive" src="@/images/stockavl.png" alt=""> <span>{{res.nostock}}</span></p>
            </div>
            <div :class="'outer01 '+(nidx < params.nostock.length-1?'':'noBorder')" v-for="(nsoh, nidx) in params.nostock">
        	<div class="thumb">
            	  <img class="img-responsive" :src="nsoh.img_tag2" alt="">
                </div>
                <div class="detail">
            	    <p>{{nsoh.pdetails.product_name}}</p>
                    <div class="blk01"><img class="img-responsive" src="@/images/barthumb.png" alt=""><span>{{res.ean}}</span><label>{{nsoh.pdetails.product_code}}</label></div>
                    <div class="blk01"><img class="img-responsive" src="@/images/productid.png" alt=""><span>{{res.productid}}</span><label>{{nsoh.pdetails.product_id}}</label></div>
                </div>
                <div class="removeBlk">
            	    <p>x{{nsoh.to_oqty}}</p>
                    <a v-on:click="removeProduct(nsoh, params.nostock)" href="javascript:void(0)">{{res.remove}}</a>
                </div>
            </div>
        </div>
        
        <div class="stockOuter stockOuter01" v-if="params.ltstock.length > 0">
        <div class="erorContent">
              <p><img class="img-responsive" src="@/images/stocknotavl.png" alt=""> <span>{{res.adstock}}</span></p>
            </div>
            <div :class="'outer01 '+(nidx < params.ltstock.length-1?'':'noBorder')" v-for="(nsoh, nidx) in params.ltstock">
        	<div class="thumb">
            	<img class="img-responsive" :src="nsoh.img_tag2" alt="">
            </div>
            <div class="detail">
            	<p>{{nsoh.pdetails.product_name}}</p>
                <div class="blk01"><img class="img-responsive" src="@/images/barthumb.png" alt=""><span>{{res.ean}}</span><label>{{nsoh.pdetails.product_code}}</label></div>
                <div class="blk01"><img class="img-responsive" src="@/images/productid.png" alt=""><span>{{res.productid}}</span><label>{{nsoh.pdetails.product_id}}</label></div>
                <div v-if="!nsoh.confirmed" class="redBlk"><img class=" img-responsive" src="@/images/rederror.png" alt="">
                  <span v-if="nsoh.to_oqty > nsoh.stock && nsoh.wbuym != 0 && nsoh.stock < (nsoh.wbuym + nsoh.wfreen)">{{subVals(res.stockleft, [nsoh.stock])}}{{res.netcost}}</span>
                  <span v-else-if="nsoh.to_oqty > nsoh.stock && nsoh.wbuym != 0">{{subVals(res.stockleft, [nsoh.stock])}}{{subVals(res.adjusting_suffix, [nsoh.to_oqty, nsoh.ad_oqty])}}</span>
                  <span v-else-if="nsoh.to_oqty > nsoh.stock">{{subVals(res.stockleft, [nsoh.stock])}}{{res.netcost}}</span>
                  <!--span v-else-if="nsoh.ad_oqty > nsoh.stock">{{subVals(res.stockleft, [nsoh.stock])}}</span-->
                  <span v-else>{{subVals(res.adjusting, [nsoh.to_oqty, nsoh.ad_oqty])}}</span>
                </div>
            </div>
            <div class="removeBlk">
            	<p>x{{nsoh.to_oqty}}</p>
                <a v-if="!nsoh.confirmed && nsoh.to_oqty < nsoh.stock" v-on:click="confirmProduct(nsoh, nsoh.to_oqty)" href="javascript:void(0)">{{res.keep}}</a>
                <a v-if="!nsoh.confirmed && nsoh.ad_oqty < nsoh.stock" v-on:click="confirmProduct(nsoh, nsoh.ad_oqty)" class="confirm" href="javascript:void(0)">{{res.confirm}}</a>
                <a v-else-if="!nsoh.confirmed" v-on:click="confirmProduct(nsoh, parseInt(nsoh.ad_oqty))" class="confirm" href="javascript:void(0)">{{res.confirm}}</a>
                <a v-if="!nsoh.confirmed" v-on:click="removeProduct(nsoh, params.ltstock)" href="javascript:void(0)">{{res.remove}}</a>
            </div>
            </div>
        </div>
		<div class="centerbutton">
            <input v-on:click="confirmAll()" class="redButon" :value="res.confirmadj" type="submit">
          </div>
      </div>
      
    </div>
  </div>
</div>
</template>

<script>

import utils from './Utils.vue'
import modalBox from './ModalBox.vue'

export default {
  extends: modalBox,
  name: 'bulkListModal',
  methods: {
    subVals(line, vals) {
      return utils.subVals(line, vals);
    },
    confirmProduct:function(product, qty) {
      product.to_oqty = parseInt(qty);
      product.confirmed = true;
      this.$forceUpdate();
    },
    removeProduct:function(product, list) {
      if (list != null) {
        for (var i=0;i<list.length;i++) {
          if (list[i].pdetails.product_id == product.pdetails.product_id) {
            list.splice(i, 1);
            break;
          }
        }
      }
      if ((this.params.nostock == null || this.params.nostock.length == 0) && (this.params.ltstock == null || this.params.ltstock.length == 0)) {
        this.close();
      }
      this.$forceUpdate();
    },
    confirmAll:function() {
      for (var i=this.params.ltstock.length-1;i>=0;i--) {
        var p = this.params.ltstock[i];
        if (p.confirmed == null) {
          p.to_oqty = p.ad_oqty;
          p.confirmed = true;
        }
console.log(p.wbuym, p.wfreen, p.to_oqty, (parseInt(p.to_oqty / (p.wbuym + p.wfreen))), (parseInt(p.to_oqty / (p.wbuym + p.wfreen)) * p.wbuym));
        if (p.wbuym != null && p.wbuym != 0) {
          if (p.to_oqty >= (p.wbuym + p.wfreen)) {
            //p.to_oqty = parseInt(p.to_oqty / (p.wbuym + p.wfreen)) * p.wbuym;
            p.to_oqty = parseInt((p.to_oqty / (p.wbuym + p.wfreen) - 0.5).toFixed(0)) * p.wbuym + (p.to_oqty % (p.wbuym + p.wfreen));
            if (p.to_oqty == 0) {
              p.to_oqty = p.stock;
            }
          }
        }
      }
      this.params.nostock = [];
      console.log('confirmall', this.params);
      if (this.params.ltstock != null) {
        for (var i=0;i<this.params.ltstock.length;i++) {
          var product = this.params.ltstock[i];
          if (product.idx >= 0) {
            this.$root.$emit('qty', {idx:product.idx, oqty:product.to_oqty});
          } else {
            this.$root.$emit('buy', {details:product, oqty:product.to_oqty});
          }
        }
        this.bulk = null;
        this.close();
      }
      this.params.ltstock = [];
      this.cartP = null;
      this.$forceUpdate();
    }
  },
  created:function() {
  }
}
</script>



// WEBPACK FOOTER //
// src/components/BulkListModal.vue